import React, { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { poppinsCustomTheme } from "../../Styles/GlobalStyles/PoppinsTheme";
import { ThemeProvider } from "@mui/material/styles";
import Slide from "@mui/material/Slide";
import {
  DialogButton,
  DialogGreyOutlinedButton,
  GreyOutlinedButton,
} from "../Button/CustomButton";
import Autocomplete from "@mui/material/Autocomplete";
import { colors, Typography } from "../../Styles/GlobalStyles/Variables";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector, useDispatch } from "react-redux";
import LoadingButton from "@mui/lab/LoadingButton";
import CustomizedTabs from "./CustomizedTabs";
import generalFunc from "../../Utils/generalFunc";
import moment from "moment";
import dayjs from 'dayjs';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import StatusGenerator from "../StatusGenerator/StatusGenerator"
import {
    Grid,
  Button,
  Divider,
  FormControl,
  IconButton,
  TextField,
  Skeleton,
  InputAdornment,
} from "@mui/material";
import { Box } from "@mui/system";
import Iconify from "../Dashboard/Iconify";
import { EditIcon } from "../MuiDataTableTheme/MuiDataTableTheme";
import SaveAsIcon from "@mui/icons-material/SaveAs";
import { StyledDivider } from "../Divider/StyledDivider";
import CircularProgress from "@mui/material/CircularProgress";
import {fetchLoans, emptyLoanById, restoreLoanInitial, updateLoan, emptyLoans } from "../../Actions";
import { errors } from "../../Utils/ErrorMessages/loans";

const getLoanState = (state) => state.loansReducer;
const getPartnerState = (state) => state.partnersReducer;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function sleep(delay = 0) {
  return new Promise((resolve) => {
    setTimeout(resolve, delay);
  });
}

export default function ViewLoanDialog(props) {

  const {
    openViewLoanDialog,
    handleCloseViewLoanDialog,
    handleOpenEditLoanDialog,
    formType,
    theParams,
    loan,
    updateLoadingState
  } = props;


    const ToastStyle = {
      backgroundColor: "#d56b66",
      color: colors.white,
    };
  
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
    const dispatch = useDispatch();

    const initialFormValues = {
      name: "",
      partnerId: 0,
      amount: "",
      sector: "",
      expiryDate: "",
    };

    const initialFormState = {
      nameError: false,
      nameErrorMsg: "",
      partnerError: false,
      partnerErrorMsg: "",
      amountError: false,
      amountErrorMsg: "",
      sectorError: false,
      sectorErrorMsg: "",
      expiryDateError: false,
      expiryDateErrorMsg: "",
      inputError:false,
    inputErrorMsg:"",
    };

    const [error, setError] = useState(false);
    const [helperText, setHelperText] = useState("");
    const [formValues, setFormValues] = useState({ ...initialFormValues });
    const [formStates, setFormStates] = useState({ ...initialFormState });
    const [loadingButton, setLoadingButton] = useState(false);
    const [disable, setDisable] = useState(colors.primaryGreen);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isUpdated, setIsUpdated] = useState(false);
    const [dateValue, setDateValue] = useState("");
    const [loanName, setLoanName] = useState("");
    const [amount, setAmount] = useState("");
    const [partnerSelect, setPartnerSelect] = useState([]);
    const [partnerName, setPartnerName] = useState("");
    const [sectorName, setSectorName] = useState("");
    const [disableField, setDisableField] = useState(true);
    const {allPartnersDataForPrinting} = useSelector(getPartnerState);
    const {loanUpdated} = useSelector(getLoanState);

    const [partnerValue, setPartnerValue] = useState({
        label: "",
        value: 0,
    })

    const [sectorValue, setSectorValue] = useState({
        label: "",
        value: 0,
    })

    const [partnerOpen, setPartnerOpen] = useState(false);
    const [partnerOptions, setPartnerOptions] = useState([]);
    const partnerLoading = partnerOpen && partnerOptions.length === 0;

    const [sectorOpen, setSectorOpen] = useState(false);
    const [sectorOptions, setSectorOptions] = useState([]);
    const sectorLoading = sectorOpen && sectorOptions.length === 0;
  

    useEffect(() => {
        if (Object.keys(loan).length > 0) {
          setLoanName(loan.name);
         setAmount(loan.amount);
         setDateValue(loan.expiryDate)
          setPartnerValue({
            label: loan.partner.name,
            value: loan.partner.id,
          });
    
          setSectorValue({
            label: loan.sector,
            value: loan.sectorId,
           });
         
        }
      }, [loan]);
    

    // const addNewLoans = () => {
    //  
    //   if (
    //     formValues.name !== "" &&
    //     formValues.partnerId !== 0 &&
    //     formValues.amount !== "" &&
    //     formValues.sector !== "" &&
    //     formValues.expiryDate !== "" 
    //   ){
    //     dispatch(addNewLoan(formValues));
    //     // setLoadingButton(true);
    //     setDisable(colors.secondaryGreen);
    //   }
    //   else {
    //     setError(true);
    //     setHelperText("Please input a loan to add")
    //   }
    //   setTimeout(() => {
    //     if (dispatch) {
    //       // setLoadingButton(false);
    //     }
    //   }, 2000);
    // };

    //This effect populates the partners select options
    useEffect(() => {
      const createPartnerSelect = () => {
        let partnerData = [];
        
        allPartnersDataForPrinting.map((key) => {
          let option = { value: key.id, label: key.name};
          return partnerData.push(option);
        });
        setPartnerSelect(partnerData);
        
      };
      allPartnersDataForPrinting.length !== 0 && createPartnerSelect();

    }, [allPartnersDataForPrinting, dispatch]);

    useEffect(() => {
      let active = true;
  
      if (!partnerLoading) {
        return undefined;
      }
  
      (async () => {
        await sleep(1e3);
        if (active) {
          setPartnerOptions(partnerSelect);
        }
      })();
  
      return () => {
        active = false;
      };
    }, [partnerLoading]);
  
    useEffect(() => {
      if (!partnerOpen) {
        setPartnerOptions([]);
      }
    }, [partnerOpen]);
  
    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        event.stopPropagation();
      }
    };
  
  const handleEdit = () => {
    handleOpenEditLoanDialog();
  };
   
    const handleClose = () => {
        setLoadingButton(false);
      handleCloseViewLoanDialog();
      setAmount("");
      setLoanName("");
      setSectorValue({
        label: "",
        value: 0,
      });
        setPartnerValue({
            label: "",
            value: 0,
        })
      setDateValue("")
      setIsSubmitted(false);
      setIsUpdated(false);
      dispatch(emptyLoanById());
    };

    const editLoanNameHandler = (e) => {
      if(e){
        let newLoannameValue = e.target.value;
        let newLoanNameValue = generalFunc.firstLetterUppercase(newLoannameValue)
        setLoanName(newLoanNameValue);
        if (newLoanNameValue === "") {
          setFormStates({
            ...formStates,
            nameError: true,
            nameErrorMsg: errors.name,
          });
          setFormValues({
            ...formValues,
            name: newLoanNameValue,
          });
        }else if (
          newLoanNameValue !== " " &&
          newLoanNameValue.length > 0
        ){
          setFormStates({
            ...formStates,
            nameError: false,
            nameErrorMsg: "",
          });
        setFormValues({
          ...formValues,
          name: newLoanNameValue,
        });
      }
      }
    };
    const editAmountHandler = (e) => {
      if(e){
        // setError(false);
        // setHelperText("");
        let newAmountValue = e.target.value.replace(/[^0-9]/g, '').slice(0, 10);
        setAmount(newAmountValue);
        if (newAmountValue === ""){
          setFormStates({
            ...formStates,
            amountError: true,
            amountErrorMsg: errors.amount,
          });
        }else if (
          newAmountValue !== " " &&
          newAmountValue.length > 0
        ) {
          setFormStates({
            ...formStates,
            amountError: false,
            amountErrorMsg: "",
          });
          setFormValues({
            ...formValues,
            amount: newAmountValue,
          });
        }
      }
    };
    const PartnerHandler = (event, val) => {
      if(event){
        setPartnerValue({
            label: val.label,
            value: val.value,
        })
        if (val.value !== 0){
          setFormStates({
            ...formStates,
            partnerError: false,
            partnerErrorMsg: "",
          });
          setFormValues({
            ...formValues,
            partnerId: val.value,
          });
        }else{
          setFormStates({
            ...formStates,
            partnerError: true,
            partnerErrorMsg: errors.partner,
          });
          setFormValues({
            ...formValues,
            partnerId: val.value,
          });
        }
      }
    };
    const SectorHandler = (event, val) => {
      if(event){
        setSectorValue({
            label: val.label,
            value: val.value,
        })
        if (val.value !== null){
          setFormStates({
            ...formStates,
            sectorError: false,
            sectorErrorMsg: "",
          });
          setFormValues({
            ...formValues,
            sector: val.value,
          });
        }else{
          setFormStates({
            ...formStates,
            sectorError: true,
            sectorErrorMsg: errors.sector,
          });
          setFormValues({
            ...formValues,
            sector: val.value,
          });
        }
      }
    };
    // const ExpiryDateHandler = (e) => {
    //   if(e){
    //     let dateValue = e.target.value;
    //     setFormValues({
    //       ...formValues,
    //       expiryDate: dateValue,
    //     });
    //   }
    // }

    const handleSubmit = () => {
        if(
            loanName !== "" &&
            amount !== "" &&
            dateValue !== "" &&
            partnerValue.label !== "" &&
            sectorValue.label !== "" 
        ) {
            setLoadingButton(true);
            dispatch(
                updateLoan({
                    name: loanName,
                    amount: amount,
                    expiryDate: dateValue,
                    partnerId: partnerValue.value,
                    sector: sectorValue.value,
                    loanId: loan.id
                })
            );
            setIsSubmitted(true);
        }else if (
          formValues.name === "" ||
          formValues.name === " " ||
      formValues.partnerId === 0 ||
      formValues.amount === "" ||
      formValues.sector === "" ||
      formValues.expiryDate === ""
        ){
          setFormStates({
            ...formStates
          })
        }
        setTimeout(() => {
            if (dispatch) {
              setLoadingButton(false);
            }
          }, 2000);
    };
   
    function resetForm() {
      setFormValues({
        ...formValues,
        name: "",
        partnerId: "",
        amount: "",
        sector: "",
        expiryDate: "",
      })
    }

    useEffect(() => {
        if (isSubmitted === true) {
          if (loanUpdated === true) {
            setIsUpdated(false);
            handleClose();
            setLoadingButton(true);
            updateLoadingState();
            dispatch(fetchLoans( theParams ));
          }
          return () => {
            dispatch(emptyLoans())
            dispatch(restoreLoanInitial());
            setLoadingButton(false);
          };
        }
      }, [loanUpdated, isSubmitted, dispatch]);



      const SECTORS = {
        Agriculture: 0,
        Construction: 1,
        Finance: 2,
        Education: 3,
        ICT: 4,
        Energy: 5,
        Entertainment: 6,
        Health: 7,
        Hospitality: 8,
        Manufacturing: 9,
        Mining: 10,
        Telecommunications: 11,
        Transportation: 12
      };

      const sectorSelect = Object.keys(SECTORS).map((sector) => ({
        label: sector,
        value: SECTORS[sector]
      }));

      useEffect(() => {
        let active = true;
    
        if (!sectorLoading) {
          return undefined;
        }
    
        (async () => {
          await sleep(1e3);
          if (active) {
            setSectorOptions(sectorSelect);
          }
        })();
    
        return () => {
          active = false;
        };
      }, [sectorLoading]);
    
      useEffect(() => {
        if (!sectorOpen) {
          setSectorOptions([]);
        }
      }, [sectorOpen]);

    return (
        <ThemeProvider theme={poppinsCustomTheme}>
          <Dialog
            fullWidth="lg"
            fullScreen={fullScreen}
            open={openViewLoanDialog}
            TransitionComponent={Transition}
            keepMounted
            aria-labelledby="draggable-dialog-title"
            PaperProps={{
              style: { borderRadius: 20, padding: 10 },
            }}
          >
            <DialogTitle
               sx={{
                fontSize: "20px",
                fontWeight: 700,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              id="responsive-dialog-title"
            > 
            <Box sx={{display: "flex",
            gap: 1,
            alignItems: "center",
          }} >
             {formType === "view" ? "View" : "Edit"} Loan Details
             <Box>
            {Object.keys(loan).length > 0 ? (
              loan.isActive === true ? (
                <StatusGenerator statusText="Active" variant="greenFilled" />
              ) : (
                <StatusGenerator statusText="Inactive" variant="redFilled" />
              )
            ) : (
              <Skeleton variant="rounded" width={50} height={30} />
            )}
          </Box>
             </Box>
              <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
            </DialogTitle>
            <Divider />
            <DialogContent
              sx={{ padding: "0px 10px", textTransform: "capitalize","&::-webkit-scrollbar": {
                width: 5,
                height: 5,
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#fff",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#DCDCDC",
                borderRadius: 2,
              }, }}
            >
                {formType === "edit" ? (
                  <Box
                    component="form"
                    sx={{
                      "& > :not(style)": { p: 3 },
                    }}
                    noValidate
                    autoComplete="off"
                  >
                    <FormControl variant="outlined" fullWidth>
                      <Grid container spacing={2}>
            
                        <Grid item xs={6}>
                          <label
                            style={{
                              marginBottom: "10px",
                              marginTop: "20px",
                              fontSize: "14px",
                              fontFamily: Typography.secondaryFont,
                            }}
                            for="loanname"
                          >
                            Loan Name
                          </label>
                          {Object.keys(loan).length > 0 ? (
                          <TextField
                            inputProps={{
                              spellCheck: true,
                              lang: "English",
                              readOnly: formType === "view" ? true : false,
                            }}
                            error={formStates.nameError}
                            helperText={formStates.nameErrorMsg}
                            size="small"
                            id="loanname"
                            variant="outlined"
                            value={generalFunc.firstLetterUppercase(loanName)}
                            onChange={(e)=>editLoanNameHandler(e)}
                          />
                          ) : (
                            <Skeleton variant="text" sx={{ fontSize: "3rem" }} />
                          )}
                        </Grid>
                        <Grid item xs={6}>
                          <label
                            style={{
                              marginBottom: "10px",
                              marginTop: "20px",
                              fontSize: "14px",
                              fontFamily: Typography.secondaryFont,
                            }}
                            for="partner"
                          >
                            Partner
                          </label>
                          {Object.keys(loan).length > 0 ? (
                          // <Autocomplete
                          //   disablePortal
                          //   id="partner"
                          //   sx={{ width: 225}}
                          //   value={partnerValue}
                          //   // defaultValue={{
                          //   //   value: formValues.partnerId,
                          //   // }}
                          //   renderInput={(params) => <TextField {...params} size="small"/>}
                          //   onChange={(event, value) => {
                          //     if (value) {
                          //       PartnerHandler(event, value);
                          //       setPartnerValue(value);
                          //     }
                          //   }}
                          //   options={partnerSelect}
                          //   getOptionLabel={(option) =>
                          //     option.label ? option.label : ""
                          //   }
                          // />
                          <Autocomplete
                          onKeyDown={handleKeyDown}
                          autoHighlight
                          id="asynchronous-demo"
                          sx={{ width: 225}}
                          open={partnerOpen}
                          onOpen={() => {
                            setPartnerOpen(true);
                          }}
                          onClose={() => {
                            setPartnerOpen(false);
                          }}
                          value={partnerValue || ""}
                          onChange={(event, value) => {
                            if (value) {
                              PartnerHandler(event, value);
                              setPartnerValue(value);
                            }
                          }}
                          isOptionEqualToValue={(option, value) => option.label === value.label}
                          getOptionLabel={(option) => option?.label || ""}
                          options={partnerOptions}
                          loading={partnerLoading}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              size="small"
                              error={formStates?.partnerError}
                              helperText={formStates?.partnerErrorMsg}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment:
                                  <React.Fragment>
                                    {partnerLoading ? (
                                      <CircularProgress color="inherit" size={20} />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                  </React.Fragment>
                              }}
                            />
                          )}
                        />
                          ) : (
                            <Skeleton variant="text" sx={{ fontSize: "3rem" }} />
                          )}
                        </Grid>
                        <Grid item xs={6}>
                          <label
                            style={{
                              marginBottom: "10px",
                              marginTop: "20px",
                              fontSize: "14px",
                              fontFamily: Typography.secondaryFont,
                            }}
                            for="amount"
                          >
                            Amount
                          </label>
                          {Object.keys(loan).length > 0 ? (
                           <TextField
                           size="small"
                           id="amount"
                           variant="outlined"
                           error={formStates.amountError}
                           helperText={formStates.amountErrorMsg}
                           value={amount}
                           onChange={(e)=>editAmountHandler(e)}
                           InputProps={{
                             inputProps: {
                               style: { textAlign: 'right' },
                               pattern: "[0-9]*",
                                maxLength: 10,
                             },
                             startAdornment: <InputAdornment position="start">₦</InputAdornment>, // Add a Naira sign to the beginning of the input field
                             value: new Intl.NumberFormat("en-NG").format(Number(amount))
                           }}
                         />
                          ) : (
                            <Skeleton variant="text" sx={{ fontSize: "3rem" }} />
                          )}
                        </Grid>
                        <Grid item xs={6}>
                          <label
                            style={{
                              marginBottom: "10px",
                              marginTop: "20px",
                              fontSize: "14px",
                              fontFamily: Typography.secondaryFont,
                            }}
                            for="sector"
                          >
                            Sector
                          </label>
                          {Object.keys(loan).length > 0 ? (
                          // <Autocomplete
                          //   disablePortal
                          //   id="sector"
                          //   sx={{ width: 225}}
                          //   value={sectorValue}
                          //     // defaultValue={{
                          //     //   value: formValues.sector,
                          //     // }}
                          //   renderInput={(params) => <TextField {...params} size="small"/>}
                          //   onChange={(event, value) => {
                          //     if (value) {
                          //       SectorHandler(event, value);
                          //       setSectorValue(value);
                          //     }
                          //   }}
                          //   options={sectorOptions}
                          //   getOptionLabel={(option) =>
                          //     option.label ? option.label : ""
                          //   }
                          // />
                          <Autocomplete
                            onKeyDown={handleKeyDown}
                            autoHighlight
                            id="asynchronous-demo"
                            sx={{ width: 225}}
                            open={sectorOpen}
                            onOpen={() => {
                              setSectorOpen(true);
                            }}
                            onClose={() => {
                              setSectorOpen(false);
                            }}
                            value={sectorValue || ""}
                            onChange={(event, value) => {
                              if (value) {
                                SectorHandler(event, value);
                                setSectorValue(value);
                              }
                            }}
                            isOptionEqualToValue={(option, value) => option.label === value.label}
                            getOptionLabel={(option) => option?.label || ""}
                            options={sectorOptions}
                            loading={sectorLoading}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                size="small"
                                error={formStates.sectorError}
                                helperText={formStates.sectorErrorMsg}
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment:
                                    <React.Fragment>
                                      {sectorLoading ? (
                                        <CircularProgress color="inherit" size={20} />
                                      ) : null}
                                      {params.InputProps.endAdornment}
                                    </React.Fragment>
                                }}
                              />
                            )}
                          />
                          ) : (
                            <Skeleton variant="text" sx={{ fontSize: "3rem" }} />
                          )}
                        </Grid>
                        <Grid item xs={'6'}>
                          <label
                            style={{
                              marginBottom: "10px",
                              marginTop: "20px",
                              fontSize: "14px",
                              fontFamily: Typography.secondaryFont,
                            }}
                            for="expirydate"
                          >
                            Expiry Date
                          </label>
                          {Object.keys(loan).length > 0 ? (
                          <LocalizationProvider dateAdapter={AdapterMoment}>
                          <DatePicker
                            disablePast
                            openTo="year"
                            views={['year', 'month', 'day']}
                            sx={{ width: 50}}
                            // inputProps={{
                            //   readOnly: formType === "view" ? true : false,
                            // }}
                            inputFormat="DD-MM-YYYY"

                            value={dateValue}
                            onChange={(newValue) => {
                              setDateValue(newValue);
                              
                              if (dateValue === ""){
                                setFormStates({
                                  ...formStates,
                                  expiryDateError: true,
                                  expiryDateErrorMsg: errors.expiryDate,
                                });
                                setFormValues({
                                  ...formValues,
                                  expiryDate: newValue?.toISOString() || '',
                                })
                              }else {
                                setFormStates({
                                  ...formStates,
                                  expiryDateError: false,
                                  expiryDateErrorMsg: "",
                                });
                                setFormValues({
                                  ...formValues,
                                  expiryDate: newValue?.toISOString() || '',
                                })
                              }
                            }}
                            renderInput={(params) => <TextField {...params} size="small" />}
                          />
                          </LocalizationProvider>
                           ) : (
                            <Skeleton variant="text" sx={{ fontSize: "3rem" }} />
                          )}
                        </Grid>
  
                        
                      </Grid>
                    </FormControl>
                  </Box>
                  ) : (
                    <Box
                    component="form"
                    sx={{
                      "& > :not(style)": { p: 3 },
                    }}
                    noValidate
                    autoComplete="off"
                  >
                    <FormControl variant="outlined" fullWidth>
                      <Grid container spacing={2}>
            
                        <Grid item xs={6}>
                          <label
                            style={{
                              marginBottom: "10px",
                              marginTop: "20px",
                              fontSize: "14px",
                              fontFamily: Typography.secondaryFont,
                            }}
                            for="loanname"
                          >
                            Loan Name
                          </label>
                          {Object.keys(loan).length > 0 ? (
                          <TextField
                            inputProps={{
                              spellCheck: true,
                              lang: "English",
                              readOnly: formType === "view" ? true : false,
                            }}
                            error={error}
                            disabled
                            sx={{
                              "& .MuiInputBase-input.Mui-disabled": {
                                WebkitTextFillColor: "#6D6D6D",
                            }
                          }}
                            helperText={helperText}
                            size="small"
                            id="loanname"
                            variant="outlined"
                            value={loan.name}
                            onChange={(e)=>editLoanNameHandler(e)}
                          />
                           ) : (
                            <Skeleton variant="text" sx={{ fontSize: "3rem" }} />
                          )}
                        </Grid>
                        <Grid item xs={6}>
                          <label
                            style={{
                              marginBottom: "10px",
                              marginTop: "20px",
                              fontSize: "14px",
                              fontFamily: Typography.secondaryFont,
                            }}
                            for="partner"
                          >
                            Partner
                          </label>
                          {Object.keys(loan).length > 0 ? (
                          <Autocomplete
                            disablePortal
                            id="partner"
                            value={partnerValue}
                            disabled
                            sx={{
                              "& .MuiInputBase-input.Mui-disabled": {
                                WebkitTextFillColor: "#6D6D6D",
                            },
                            width: 225,
                          }}
                            // defaultValue={{
                            //   value: formValues.partnerId,
                            // }}
                            renderInput={(params) => <TextField {...params} size="small"/>}
                            onChange={(event, value) => {
                              if (value) {
                                PartnerHandler(event, value);
                                setPartnerValue(value);
                              }
                            }}
                            options={partnerSelect}
                            getOptionLabel={(option) =>
                              option.label ? option.label : ""
                            }
                          />
                           ) : (
                            <Skeleton variant="text" sx={{ fontSize: "3rem" }} />
                          )}
                        </Grid>
                        <Grid item xs={6}>
                          <label
                            style={{
                              marginBottom: "10px",
                              marginTop: "20px",
                              fontSize: "14px",
                              fontFamily: Typography.secondaryFont,
                            }}
                            for="amount"
                          >
                            Amount
                          </label>
                          {Object.keys(loan).length > 0 ? (
                             <TextField
                             size="small"
                             id="amount"
                             variant="outlined"
                            //  error={formStates.amountError}
                            //  helperText={formStates.amountErrorMsg}
                             value={loan.amount}
                             onChange={(e)=>editAmountHandler(e)}
                             disabled
                            sx={{
                              "& .MuiInputBase-input.Mui-disabled": {
                                WebkitTextFillColor: "#6D6D6D",
                            }
                          }}
                             InputProps={{
                               inputProps: {
                                 style: { textAlign: 'left' },
                                 readOnly: formType === "view" ? true : false,
                               },
                               startAdornment: <InputAdornment position="start">₦</InputAdornment>, // Add a Naira sign to the beginning of the input field
                               value: new Intl.NumberFormat("en-NG").format(Number(loan.amount))
                             }}
                           />
                          // <TextField
                          //   inputProps={{
                          //     // style: { height: "20px" },
                          //     spellCheck: true,
                          //     lang: "English",
                          //     readOnly: formType === "view" ? true : false,
                          //   }}
                          //   disabled
                          //   sx={{
                          //     "& .MuiInputBase-input.Mui-disabled": {
                          //       WebkitTextFillColor: "#6D6D6D",
                          //   }
                          // }}
                          //   size="small"
                          //   id="amount"
                          //   variant="outlined"
                          //   value={loan.amount}
                          //   onChange={(e)=>editAmountHandler(e)}
                          // />
                           ) : (
                            <Skeleton variant="text" sx={{ fontSize: "3rem" }} />
                          )}
                        </Grid>
                        <Grid item xs={6}>
                          <label
                            style={{
                              marginBottom: "10px",
                              marginTop: "20px",
                              fontSize: "14px",
                              fontFamily: Typography.secondaryFont,
                            }}
                            for="sector"
                          >
                            Sector
                          </label>
                          {Object.keys(loan).length > 0 ? (
                          <Autocomplete
                            disablePortal
                            id="sector"
                            disabled
                            sx={{
                              "& .MuiInputBase-input.Mui-disabled": {
                                WebkitTextFillColor: "#6D6D6D",
                            },
                            width: 225,
                          }}
                            value={sectorValue}
                              // defaultValue={{
                              //   value: formValues.sector,
                              // }}
                            renderInput={(params) => <TextField {...params} size="small"/>}
                            onChange={(event, value) => {
                              if (value) {
                                SectorHandler(event, value);
                                setSectorValue(value);
                              }
                            }}
                            options={sectorOptions}
                            getOptionLabel={(option) =>
                              option.label ? option.label : ""
                            }
                          />
                           ) : (
                            <Skeleton variant="text" sx={{ fontSize: "3rem" }} />
                          )}
                        </Grid>
                        <Grid item xs={'6'}>
                          <label
                            style={{
                              marginBottom: "10px",
                              marginTop: "20px",
                              fontSize: "14px",
                              fontFamily: Typography.secondaryFont,
                            }}
                            for="expirydate"
                          >
                            Expiry Date
                          </label>
                          {Object.keys(loan).length > 0 ? (
                          <LocalizationProvider dateAdapter={AdapterMoment}>
                          <DatePicker
                            disablePast
                            openTo="year"
                            views={['year', 'month', 'day']}
                            inputProps={{
                              readOnly: formType === "view" ? true : false,
                            }}
                            inputFormat="DD-MM-YYYY"
                            disabled
                          //   // sx={{
                          //   //   "& .MuiInputBase-input.Mui-disabled": {
                          //   //     WebkitTextFillColor: "#6D6D6D",
                          //   // },
                          //   width: 50,
                          // }}
                            value={loan.expiryDate}
                            onChange={(newValue) => {
                              setDateValue(newValue);
                              setFormValues({
                                ...formValues,
                                expiryDate: newValue?.toISOString() || '',
                              })
                            }}
                            renderInput={(params) => 
                              <TextField {...params} 
                              sx={{
                                "& .MuiInputBase-input.Mui-disabled": {
                                  color: "#6D6D6D",
                                },
                              }}
                              disabled
                                error={false} 
                                size="small" 
                              />
                            }
                          />
                          </LocalizationProvider>
                          ) : (
                            <Skeleton variant="text" sx={{ fontSize: "3rem" }} />
                          )}
                        </Grid>
                        <Grid item xs={6}>
                          <label
                            style={{
                              marginBottom: "10px",
                              marginTop: "20px",
                              fontSize: "14px",
                              fontFamily: Typography.secondaryFont,
                            }}
                            for="noOfBeneficiaries"
                          >
                            No of Beneficiaries
                          </label>
                          {Object.keys(loan).length > 0 ? (
                          <TextField
                            inputProps={{
                              spellCheck: true,
                              lang: "English",
                              readOnly: formType === "view" ? true : false,
                            }}
                            disabled
                            sx={{
                              "& .MuiInputBase-input.Mui-disabled": {
                                WebkitTextFillColor: "#6D6D6D",
                            }
                          }}
                            size="small"
                            id="noOfBeneficiaries"
                            variant="outlined"
                            value={loan.loanBeneficiary.length}
                            onChange={(e)=>editLoanNameHandler(e)}
                          />
                           ) : (
                            <Skeleton variant="text" sx={{ fontSize: "3rem" }} />
                          )}
                        </Grid>
                        
                      </Grid>
                    </FormControl>
                  </Box>
                  )}
             
            </DialogContent>
            
            {/* {formType === "view" || "edit" ? ( */}
            
            <DialogActions sx={{ textTransform: "capitalize", p: 3 }}>
              <GreyOutlinedButton
                sx={{ fontFamily: Typography.secondaryFont, padding: "10px 25px" }}
                autoFocus
                onClick={handleClose}
              >
                {formType === "view" ? <>Close</> : <>Cancel</>}
              </GreyOutlinedButton>
              {formType === "view" ? (
                  <Button
                    onClick={handleEdit}
                    startIcon={<EditIcon icon="icon-park-outline:edit" />}
                    sx={{
                      textTransform: "capitalize",
                      color: colors.primaryYellow,
                      borderColor: colors.primaryYellow,
                      padding: "10px 30px",
                      "&:hover": { borderColor: colors.primaryYellow },
                    }}
                    variant="outlined"
                  >
                    Edit Loan
                  </Button>
                ) : formType === "edit" ? (
                  <LoadingButton
                  loading={loadingButton}
                    disableElevation
                    startIcon={<SaveAsIcon icon="icon-park-outline:edit" />}
                    sx={{
                      textTransform: "capitalize",
                      color: "#fff",
                      borderColor: colors.primaryGreen,
                      "&:hover": { borderColor: colors.primaryGreen },
                      padding: "10px 30px",
                    }}
                    variant="contained"
                    onClick={() => {
                        handleSubmit();
                      }}
                  >
                    Save Changes
                  </LoadingButton>
                ) : (
                  ""
                )}
            </DialogActions>
            {/* ) : ("")} */}
            <ToastContainer toastStyle={ToastStyle} />
          </Dialog>
        </ThemeProvider>
      );


  };